import React from 'react';
import ContentComponent from '../Content/Content.component';
import PropTypes from 'prop-types';
import './Steps.scss';

/**
 * @group Components
 * Displays article steps
 */

const Steps = (props) => {
  const { Content } = props.opts;
  return (
    <div className="step">
      {props.children}
      {Content.map((step, index) => {
        return (
          <div key={step.name}>
            <div className="step-header">
              <span id={step.name} className="stepnum">{step.stepCount}</span>
              <div className="step-title">
                {step.text}
              </div>
            </div>
            <div>
              {step.Content.map((c, i) => {
                return (
                  <ContentComponent
                    channel={props.channel}
                    contentType={props.contentType}
                    deliveryZip={props.deliveryZip}
                    dimensions={props.dimensions}
                    disableSwipeNavigation={props.disableSwipeNavigation}
                    dpdResponse={props.dpdResponse}
                    env={props.env}
                    exclude={props.exclude}
                    favorites={props.favorites}
                    host={props.host}
                    isCategory={props.isCategory}
                    key={c.id || i}
                    keyword={props.keyword}
                    linkType={props.linkType}
                    navParam={props.navParam}
                    onFavoriteChange={props.onFavoriteChange}
                    onVisNavRender={props.onVisNavRender}
                    opts={c}
                    parentNavParam={props.parentNavParam}
                    partialTemplates={props.partialTemplates}
                    plpBanner={props.plpBanner}
                    showArrows={props.showArrows}
                    showFavoritesCount={props.showFavoritesCount}
                    showDpdPod={props.showDpdPod}
                    sku={props.sku}
                    storeId={props.storeId}

                    visualNavPromos={props.visualNavPromos}
                    visualNavResults={props.visualNavResults}
                  />
                );
              })}
            </div>
          </div>
        );
      })}
    </div>
  );
};

Steps.propTypes = {
  opts: PropTypes.shape({
    stepCount: PropTypes.string,
    text: PropTypes.string,
    name: PropTypes.string,
    Content: PropTypes.array,
  }).isRequired,
  children: PropTypes.instanceOf(Array)
};

Steps.defaultProps = {
  children: []
};

export default Steps;
